/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(document).ready(function() {
  const product_group_text_field = $(".product_group_text_field");

  if (product_group_text_field.size() > 0) {
    const suggestion_template = $.parseJSON(product_group_text_field.data("suggestion-template"));
    const suggestion_function = (object, forwarded_args) => suggestion_template.replace("{{value}}", object.description).replace('{{image_path}}', object.image_path);

    const dataSet = {
        source(query, cb) {
          return $.get(product_group_text_field.data("source"), {query}, data => cb(data.options));
        },
        templates: {
          suggestion: suggestion_function
        }
      };
    
    const brandDataSet = {
      source(query, cb) { 
        return $.get(product_group_text_field.data("brand-source"), {query}, data => cb(data.options));
      },
      displayKey: "value"
    };

    const options = {
        minLength: 2,
        debug: false,
        autoselect: true
      };

    product_group_text_field.autocomplete(options, dataSet, brandDataSet).bind('autocomplete:selected', (event, suggestion, dataset) => document.location = suggestion.href);
  }

  if ($("#filter_products_form").length > 0) { 
    return $(document).on("click", ".bs-donebutton", event => $("#filter_products_form").submit());
  }
});